export default {
    //葡萄牙语
    DiagnosticReport:'Relatório diagnóstico',
    troubleCode:'Código da falha',
    time:'tempo',
    noTItle:'Controlo do fabricante',
    TestReport:'Relatório de teste',
    VehicleInformation:'Informações do veículo',
    DataStream:'Fluxo de dados',
    IMReadiness:'Preparação I/M',
    Communication:'Protocolo de comunicação',
    notFaultCode:'Sem código de falha',
    nodataflow:'Sem fluxo de dados anormal',
    PositioningPrompt:'Ative o geolocalização para obter preços locais.',
    FaultCode:'código de falha',
    AIDiagnosis:'Diagnóstico por IA',
    AIWait:'Relatório de IA ou aguardando diagnóstico automático',
    FailedFaultCode:'Não foi possível obter informações sobre o código de falha',
    AIError:'Análise de IA falhada',
    more:'mais',
    StoredCodes:'Stored Codes',
    PendingCodes:'Pending Codes',
    PermanentCodes:'Permanent Codes',
    ManufacturerControl:'Controlo do fabricante',
    continue:'continuar',
    // 引导定位
    notlimits:'Não foi possível obter permissão de localização',
    setupSteps:'Passos de configuração:',
    openset:'Abra o aplicativo "Configurações"',
    findSet:'Encontre o aplicativo que você está usando',
    clickset:'Toque em "Localização"',
    selectLimits:'Selecione "Durante o uso" ou "Sempre"',
    blackRefresh:'Volte ao aplicativo e atualize a página',
    openAppSet:'Toque em "Gerenciamento de aplicativos" ou "Aplicativos"',
    findUseBrowser:'Encontre o navegador que você está usando',
    clickAuthority:'Toque em "Gerenciamento de permissões"',
    findejurisd:'Encontre a permissão de "Localização"',
    selectjurisd:'Selecione "Permitir" ou "Permitir durante o uso"',
    phoneJurisd:'Verifique a permissão de localização do aplicativo no telefone:',
    openJurisd:'Ative a permissão de "Localização"',
    report:'AI',
    AI:'Relatório',
    Freeze:'Congelar a Moldura',
    VoltageInfo:'Informações de tensão',
    Voltage:'Tensão elétrica',
    Agent:'Agent'
}